import {
  NavLink as RouterLink,
  matchPath,
  useLocation
} from 'react-router-dom';
import PropTypes from 'prop-types';
import { Button, Chip, Icon, ListItem } from '@mui/material';
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useState } from 'react';
import { List } from '@mui/material';
import goodalipi from 'src/plugins/goodalipi';
import { sendAnalyticsEvents } from 'src/analytics/snowplow';
import { SNOWPLOW_EVENTS_NAME, EVENT_KEYS } from 'src/analytics/constants';

const NavItem = ({
  item,
  ...rest
}) => {

  const hasChildren = (item) => {
    const { options } = item;
    return options.length ? true : false
  }
  const location = useLocation();

  const SingleLevel = ({ item, sectionType }) => {
    const active = item.href ? !!matchPath({
      path: item.href,
      end: false
    }, location.pathname) : false;
    const { icon: MainIcon } = item
    return (
      <>
        {
          <ListItem
            disableGutters
            sx={{
              display: 'flex',
              py: 0,
              mb: 0.5,
            }}
          >
            <Button
              component={RouterLink}
              sx={{
                color: 'white',
                fontWeight: 'medium',
                justifyContent: 'flex-start',
                letterSpacing: 0,
                py: 1.25,
                pl: 1,
                textTransform: 'none',
                width: '100%',
                borderRadius: 3,
                ...(!active && {
                  ":hover": {
                    bgcolor: '#4794f5'
                  }
                }),
                ...(active && {
                  color: 'primary.main',
                  // bgcolor: 'white',
                  backgroundImage: `url(${"/static/images/test.png"})`,
                  backgroundPosition: 'center',
                  // ":hover": {
                  //   bgcolor: 'white'
                  // }
                }),
                '& svg': {
                  mr: 1
                }
              }}
              to={!item.disable ? item.href : location.pathname}
              onClick={() => {
                const user = goodalipi.get('user');
                const email = user?.emailId||"";
                const userName = user?.baseProfileData?.userName||"";
                sendAnalyticsEvents(SNOWPLOW_EVENTS_NAME.HRWIN_SECTION_SELECTED, {
                  [EVENT_KEYS.SECTION_TYPE]: sectionType||"",
                  [EVENT_KEYS.SECTION_NAME]: item.title||"", 
                  [EVENT_KEYS.EMAIL]: email,
                  [EVENT_KEYS.USERNAME]: userName
                })
              }}
              startIcon={
                item.customIcon && <Icon fontSize="small">
                  <img style={{ 'width': 'auto', 'height': 'auto', 'maxWidth': '100%', 'maxHeight': '100%', 'marginBottom': '4px' }} alt="edit" src={`/static/images/${item.customIcon}.svg`} />
                </Icon>
              }
            >
              {MainIcon && (
                <MainIcon size="20" />
              )}
              <span>
                {item.title}
              </span>
              {item.badge && <Chip sx={{ ml: 10, fontSize: 10 }} color="secondary" size="small" label="coming soon" />}
            </Button>
          </ListItem>
        }
      </>
    )
  }
  const svgIcon = (
    <Icon fontSize="small">
      <img style={{ 'width': 'auto', 'height': 'auto', 'maxWidth': '100%', 'maxHeight': '100%', 'marginBottom': '4px' }} alt="edit" src="/static/images/vaccination.svg" />
    </Icon>
  );

  const MultiLevel = ({ item }) => {
    const { options } = item;
    // const { icon: MainIcon } = item;
    const [open, setOpen] = useState(true);
    const handleClick = () => {
      setOpen((prev) => !prev);
    };

    return (
      <>
        <ListItem
          disableGutters
          sx={{
            // display: 'flex',
            py: 0,
          }}
        >
          {/* <Icon fontSize="small">
      <img style={{ 'width': 'auto', 'height': 'auto', 'maxWidth': '100%', 'maxHeight': '100%' }} alt="edit" src="/static/images/vaccination.svg" />
    </Icon> */}
          <Button
            sx={{
              color: 'white',
              // fontSize: 17,
              fontWeight: 'medium',
              justifyContent: 'flex-start',
              letterSpacing: 0,
              py: 1.25,
              textTransform: 'none',
              width: '100%',
              '& svg': {
                mr: 1
              }
            }}
            startIcon={
              <Icon fontSize="small">
                <img style={{ 'width': 'auto', 'height': 'auto', 'maxWidth': '100%', 'maxHeight': '100%', 'marginBottom': '4px' }} alt="edit" src={`/static/images/${item.icon}.svg`} />
              </Icon>
            }
            // endIcon={open ? <ExpandLessIcon sx={{ ml: 10 }}/> : <ExpandMoreIcon sx={{ ml: 10 }}/>}
            onClick={handleClick}
          >
            {false && MainIcon && (
              <MainIcon size="20" />
            )}
            <span>
              {item.title}
            </span>
          </Button>
        </ListItem>
        <Collapse in={open} timeout="auto">
          <List sx={{ pl: 3 }} component="div" disablePadding>
            {options.map((child, key) => (
              <SingleLevel 
              key={key} item={child}
              sectionType={item.title}
              ></SingleLevel>
            ))}
          </List>
        </Collapse>
      </>
    );
  };


  const Component = hasChildren(item) ? MultiLevel : SingleLevel;
  return (
    <>
      {/* <ListItem
      disableGutters
      sx={{
        display: 'flex',
        py: 0
      }}
      {...rest}
    >
      <Button
        component={RouterLink}
        sx={{
          color: 'text.secondary',
          fontWeight: 'medium',
          justifyContent: 'flex-start',
          letterSpacing: 0,
          py: 1.25,
          textTransform: 'none',
          width: '100%',
          ...(active && {
            color: 'primary.main'
          }),
          '& svg': {
            mr: 1
          }
        }}
        to={href}
      >
        {Icon && (
          <Icon size="20" />
        )}
        <span>
          {title}
        </span>
      </Button>
    </ListItem>
     */}
      <Component item={item} />
    </>
  );
};

NavItem.propTypes = {
  item: PropTypes.object
};

export default NavItem;
